import { alpha } from '@mui/material/styles';

export const ADMIN_LAYOUT = {
  contentMaxWidth: 1680,
  shellPaddingX: { xs: 1.1, sm: 1.4, md: 1.8 },
  shellPaddingY: { xs: 1, sm: 1.2, md: 1.5 },
  shellPaddingBottom: { xs: 5.2, md: 6 },
  pagePadding: { xs: 1.4, sm: 1.8, md: 2.2 },
  pagePaddingCompact: { xs: 1.2, sm: 1.6, md: 2 },
  headerMinHeight: { xs: 80, md: 92 },
  containerPaddingPx: { xs: 20, sm: 28, md: 34 },
  routeFrameRadius: 0,
  shellOuterRadius: { xs: 0, md: 0 },
  sidebarRadius: { xs: 0, md: 0 },
  headerRadius: { xs: 0, md: 0 },
};

export const getAdminShellBackground = (theme) =>
  theme.palette.background.default;

export const getAdminSidebarPaperBackground = (theme) =>
  theme.palette.background.paper;

export const getAdminSidebarSelectedBackground = (theme) =>
  alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.22 : 0.12);

export const getAdminSidebarSelectedHoverBackground = (theme) =>
  alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.3 : 0.18);
